import React, { useState, useEffect, useCallback } from 'react';
import HelpPanel from '@amzn/awsui-components-console/help-panel';
import Link from '@amzn/awsui-components-console/link';
import Box from '@amzn/awsui-components-console/box';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import { ExternalLinkItem } from '../ExternalLinkItem.jsx';
import { helpContent, navigationItems } from './HelpPanelContent';

interface AppHelpPanelProps {
	currentPage?: string;
}

const AppHelpPanel: React.FC<AppHelpPanelProps> = ({ currentPage = 'overview' }) => {
	const [selectedTopic, setSelectedTopic] = useState<string>(currentPage);

	useEffect(() => {
		setSelectedTopic(currentPage);
	}, [currentPage]);

	const handleNavigation = useCallback((key: string) => {
		setSelectedTopic(key);
	}, []);

	const currentContent = helpContent[selectedTopic] || helpContent.overview;

	return (
		<HelpPanel
			header={
				<SpaceBetween size="xs">
					<Box variant="h2">Help & Documentation</Box>
					<nav aria-label="Help panel navigation">
						<SpaceBetween size="xxs">
							{navigationItems.map((item) => (
								<Box
									key={item.key}
									padding={{ vertical: 'xxs', horizontal: 'xs' }}
								>
									<Link
										variant={selectedTopic === item.key ? 'primary' : 'secondary'}
										onFollow={() => handleNavigation(item.key)}
										ariaLabel={`Navigate to ${item.label} help section`}
									>
										{item.label}
									</Link>
								</Box>
							))}
						</SpaceBetween>
					</nav>
				</SpaceBetween>
			}
			footer={
				currentContent.links && currentContent.links.length > 0 && (
					<SpaceBetween size="xs">
						<Box variant="h3">Quick Links</Box>
						<ul>
							{currentContent.links.map((link, i) => (
								<li key={i}>
									<ExternalLinkItem
										href={link.href}
										text={link.text}
									/>
								</li>
							))}
						</ul>
					</SpaceBetween>
				)
			}
		>
			<SpaceBetween size="s">
				<Box variant="h3">{currentContent.title}</Box>
				{currentContent.content}
			</SpaceBetween>
		</HelpPanel>
	);
};

export default AppHelpPanel;
